import {Stack} from '@primer/react'
import {useGetPendingCommentsFromStoreWithoutDiffEntries} from '../../../../hooks/use-generate-pending-comments'
import {usePendingReviews} from '../../../../stores/layout-selectors'
import {PendingCommentPreview} from '../../../comments/PendingCommentPreview'

export function PendingCommentsPreview() {
  const pendingReview = usePendingReviews()
  const commentsList = useGetPendingCommentsFromStoreWithoutDiffEntries(pendingReview.pendingReviewIDs)

  return (
    <Stack direction="vertical" spacing="normal" paddingBlock="condensed">
      {commentsList?.map(pendingComment => (
        <PendingCommentPreview key={pendingComment.commentID} pendingComment={pendingComment} />
      ))}
    </Stack>
  )
}
